import type { APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type IImpact = APIResponse<'/api/v4/impacts'>[number];

export const fetchImpacts = async () => get<IImpact[]>('/v4/impacts');
